import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import Features from "@/components/Features";
import Footer from "@/components/Footer";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const Index = () => {
  const { t } = useTranslation();
  const cta = useScrollReveal<HTMLElement>({ threshold: 0.2 });
  const marqueeItems = t("marquee", { returnObjects: true }) as string[];

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Seo title={t("seo.home.title")} description={t("seo.home.desc")} path="/" />
      <Header />
      <main id="main" tabIndex={-1} className="flex-1 outline-none">
        <HeroSection />
        <div className="border-t border-border" />
        <Features />

        {/* Editorial ticker - hairline framed */}
        <div className="border-t border-border" />
        <div className="py-5 overflow-hidden select-none">
          <div className="animate-marquee flex whitespace-nowrap items-center">
            {[...marqueeItems, ...marqueeItems].map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="ed-serif text-muted-foreground/30 text-lg px-6">·</span>
                <span className="ed-eyebrow text-foreground/70">{item}</span>
              </span>
            ))}
          </div>
        </div>
        <div className="border-t border-border" />

        {/* Final CTA - bold editorial closer, scroll triggered */}
        <section
          ref={cta.ref}
          className="relative w-full px-6 py-24 md:py-36"
          aria-labelledby="cta-title"
        >
          <div className="max-w-[1400px] mx-auto">
            <p className={`ed-eyebrow text-muted-foreground reveal reveal-up ${cta.isVisible ? "visible" : ""}`}>
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand mr-2.5 align-middle" />
              {t("cta.eyebrow")}
            </p>

            <h2
              id="cta-title"
              className={`ed-display mt-6 max-w-5xl reveal reveal-up reveal-delay-1 ${cta.isVisible ? "visible" : ""}`}
            >
              {t("cta.heading")}<span className="text-brand">?</span>
            </h2>

            <div className="mt-10 flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
              <p className={`ed-serif text-2xl md:text-3xl max-w-md text-foreground/85 reveal reveal-blur reveal-delay-2 ${cta.isVisible ? "visible" : ""}`}>
                {t("cta.sub")}
              </p>

              <div className={`flex flex-wrap gap-3 reveal reveal-up reveal-delay-3 ${cta.isVisible ? "visible" : ""}`}>
                <a href="/contact" className="ed-btn ed-btn-solid">
                  {t("cta.talkToUs")}
                </a>
                <a href="/products" className="ed-btn">
                  {t("cta.seeProducts")}
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
